import axios from "axios";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { createRef } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsXCircle } from "react-icons/bs";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { TiDelete } from "react-icons/ti";
import { toast } from "react-toastify";

import {
  academic,
  interests,
  jobStatus,
  languages,
  options,
  socialMediaList,
  socialMediaReach,
  validationErrorMessage,
} from "../../../Utils/constants";
import { CustomDropdown } from "../../../Utils/dropdown";
import { getLocalStorage, updateTiersData, verifyTiers1Completion } from "../../../Utils/localStorage";

const Tier2 = (props) => {
  const formRef = useRef(null);
  const saveRef = useRef(null);
  const socialMediaUrlRef = useRef(null);

  const socialMediaPlatformRef = createRef();
  const [socialMedia, setSocialMedia] = useState([]);
  const [spokenLanguages, setSpokenLanguages] = useState([]);
  const [userInterests, setUserInterests] = useState([]);
  const [socialMediaListState, setSocialMediaListState] = useState(
    getLocalStorage("t2")?.socialMedia !== undefined
      ? socialMediaList.filter((a) => !getLocalStorage("t2").socialMedia[a.value])
      : socialMediaList
  );
  const [showTier, setShowTier] = useState(false);
  const regex = new RegExp("^(http|https)://", "i");

  const [refetch, setRefetch] = useState(false);

  const [platformValues, setPlatformValues] = useState([]);

  const [validation, setValidation] = useState({
    age: {
      error: false
    },
    about: {
      error: false
    },
    language: {
      error: false
    },
    interests: {
      error: false
    },
    academic: {
      error: false
    },
    jobStatus: {
      error: false
    },
    socialMediaReach: {
      error: false
    },
    platform: {
      error: false
    }
  });

  const CreateElements = (props) => {
    return React.createElement(
      "div",
      {
        className: "d-flex mb-3 position-relative flex-sm-row flex-column",
        "data-category": props?.label,
        "data-test": props?.index
      },
      React.createElement(CustomDropdown, {
        name: "socialMediaPlatform[]",
        width: "250px",
        ref: socialMediaPlatformRef,
        options: socialMediaListState,
        valueChanged: (e) => {
          setSocialMediaListState(socialMediaListState.filter((a) => a.value !== e.value));
        },
        defaultValue: props.label ? { label: props.label, value: props.label } : false
      }),
      React.createElement("input", {
        ref: socialMediaUrlRef,
        name: "socialMediaUrl[]",
        className: "ms-sm-3 mt-sm-0 mt-3",
        defaultValue: props.value ? props.value : "",
        placeholder: "https://example.com",
        onBlur: (e) => {
          if (
            !regex.test(socialMediaUrlRef.current.value) &&
            socialMediaUrlRef.current.value !== ""
          ) {
            toast.warn("The URL entered does not appear to be valid. Please add https://", {
              toastId: "url_valid",
              hideProgressBar: true,
              style: options.dropdownStyle
            });
            setValidation((prevState) => ({
              ...prevState,
              platform: {
                error: true
              }
            }));
          } else {
            setPlatformValues((prevState) => ({
              ...prevState,
              [socialMediaPlatformRef?.current.getValue()[0]?.value]: e.target.value
            }));
            setValidation((prevState) => ({
              ...prevState,
              platform: {
                error: false
              }
            }));
          }
        },
        onKeyPress: (e) => {
          if (socialMediaPlatformRef?.current.getValue()[0]?.value === undefined) {
            e.preventDefault();
            toast.warn("You must choose a platform", {
              toastId: "platformError",
              hideProgressBar: true,
              style: options.dropdownStyle
            });
          } else {
            socialMediaUrlRef.current.name = socialMediaPlatformRef?.current.getValue()[0]?.value;
          }
        }
      }),
      React.createElement(
        "button",
        {
          className: "p-0 m-0 border-0 position-absolute handleRemoveDynamic",
          onClick: (e) => {
            e.preventDefault();

            let obj = {};

            if (getLocalStorage("t2")?.socialMedia) {
              let s = e.currentTarget.parentNode.getAttribute("data-category");

              if (Object.keys(getLocalStorage("t2")?.socialMedia).length <= 1) {
                setValidation((prevState) => ({
                  ...prevState,
                  platform: {
                    error: true
                  }
                }));
                return;
              }

              Object.entries(getLocalStorage("t2")?.socialMedia).forEach((remove) => {
                if (remove[0] !== s) {
                  obj[remove[0]] = remove[1];
                }
              });

              setPlatformValues(obj);

              setTimeout(() => {
                saveRef.current.click();
              }, 100);
            }

            if (getLocalStorage("t2")?.socialMedia === undefined) {
              Object.entries(platformValues).forEach((social) => {
                if (social[0] !== props?.label) {
                  obj[social[0]] = social[1];
                }
              });

              let indexOfParent = +e.currentTarget.parentNode.getAttribute("data-test") + 1;
              let totalLength = e.currentTarget.parentNode.parentNode.children.length;

              if (indexOfParent === totalLength) {
                setSocialMedia(socialMedia.filter((a) => a.key !== indexOfParent));
              }

              if (Object.keys(obj).length === 0) {
                setPlatformValues([]);
              } else {
                setPlatformValues(obj);
              }
            }
          }
        },
        <BsXCircle color="#e74c3c" fontSize="22px" />
      )
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setRefetch(!refetch);
    props?.onUpdate(!refetch);

    const data = new FormData(formRef.current);
    const formData = Object.fromEntries(data);

    let error = false;

    setValidation({
      age: {
        error: false
      },
      about: {
        error: false
      },
      language: {
        error: false
      },
      interests: {
        error: false
      },
      academic: {
        error: false
      },
      jobStatus: {
        error: false
      },
      socialMediaReach: {
        error: false
      },
      platform: {
        error: false
      }
    });

    /**
     * Validations
     */
    if (formData.age === "") {
      setValidation((prevState) => ({
        ...prevState,
        age: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.about === "") {
      setValidation((prevState) => ({
        ...prevState,
        about: {
          error: true
        }
      }));
      error = true;
    }

    if (spokenLanguages.length === 0) {
      setValidation((prevState) => ({
        ...prevState,
        language: {
          error: true
        }
      }));
      error = true;
    }

    if (userInterests.length === 0) {
      setValidation((prevState) => ({
        ...prevState,
        interests: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.academic === "") {
      setValidation((prevState) => ({
        ...prevState,
        academic: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.jobStatus === "") {
      setValidation((prevState) => ({
        ...prevState,
        jobStatus: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.socialMediaReach === "") {
      setValidation((prevState) => ({
        ...prevState,
        socialMediaReach: {
          error: true
        }
      }));
      error = true;
    }

    if (platformValues.length === 0) {
      setValidation((prevState) => ({
        ...prevState,
        platform: {
          error: true
        }
      }));
      error = true;
    }

    if (!verifyTiers1Completion()) {
      error = true;
      toast.error("You must complete Contact information form", {
        toastId: "noTier1",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
    }
    if (!error) {
      // Send info to server
      if (e.currentTarget.className.includes("submit-now")) {
        props?.openModal();
      }

      if (!e.currentTarget.className.includes("submit-now")) {
        toast.success("Successfully updated About you information.", {
          toastId: "updated1",
          hideProgressBar: true,
          style: options.dropdownStyle
        });
      }

      localStorage.setItem("tier2", true);

      localStorage.setItem(
        "t2",
        JSON.stringify({
          age: formData.age,
          about: formData.about,
          languages: spokenLanguages,
          interests: userInterests,
          academic: formData.academic,
          jobStatus: formData.jobStatus,
          socialMediaReach: formData.socialMediaReach,
          socialMedia: platformValues
        })
      );
    }
  };

  useEffect(() => {
    if (spokenLanguages.length === 0 && getLocalStorage("t2")?.languages) {
      setSpokenLanguages(getLocalStorage("t2")?.languages);
    }
    if (userInterests.length === 0 && getLocalStorage("t2")?.interests) {
      setUserInterests(getLocalStorage("t2")?.interests);
    }
  }, []);

  useEffect(() => {
    if (getLocalStorage("t2")?.socialMedia) {
      setSocialMedia([]);

      Object.entries(getLocalStorage("t2")?.socialMedia).forEach((social, index) => {
        setSocialMediaListState(socialMediaListState.filter((a) => a.value !== social[0]));

        setPlatformValues((prevState) => ({
          ...prevState,
          [social[0]]: social[1]
        }));

        setSocialMedia((prevState) => [
          ...prevState,
          <CreateElements label={social[0]} value={social[1]} key={index} />
        ]);
      });
    }
  }, [refetch]);

  useEffect(() => {
    if (localStorage.getItem("tier1")) setShowTier(true);
  }, [props?.refetch]);

  return (
    <form autoComplete="off" ref={formRef} className="row">
      <div className="form-wrapper p-sm-5 p-4">
        <div className="row mb-4">
          <div className="col-12">
            <h1 className="font-pnsb mb-0 tier2">About you</h1>
            <small className="font-pnsb mb-4 tier2 text-light">
              {showTier
                ? "Fields marked with * are mandatory"
                : "You need to complete Contact information"}
            </small>
          </div>
        </div>

        {showTier ? (
          <>
            <div className="row mb-4">
              <div className="col-12">
                <label htmlFor="age" className={validation.age.error ? "mb-0" : null}>
                  Age *
                </label>
                {validationErrorMessage(validation.age.error)}
                <input
                  type="number"
                  min={18}
                  max={100}
                  id="age"
                  name="age"
                  className={validation.age.error ? "error" : null}
                  defaultValue={getLocalStorage("t2")?.age ? getLocalStorage("t2").age : false}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-12">
                <label htmlFor="about" className={validation.about.error ? "mb-0" : null}>
                  About you *
                </label>

                {validationErrorMessage(validation.about.error)}

                <textarea
                  name="about"
                  id="about"
                  className={validation.about.error ? "error" : null}
                  defaultValue={
                    getLocalStorage("t2")?.about ? getLocalStorage("t2").about : ""
                  }></textarea>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-lg-3">
                <label
                  htmlFor="socialMediaReach"
                  className={validation.language.error ? "mb-0" : null}>
                  Languages *
                </label>
                {validationErrorMessage(validation.language.error)}
                <CustomDropdown
                  className={validation.language.error ? "error-dropdown" : ""}
                  valueChanged={(e) => {
                    if (spokenLanguages.includes(e.label)) {
                      toast.warn("This language is already added.", {
                        toastId: "languageAlreadyAdded",
                        hideProgressBar: true,
                        style: options.dropdownStyle
                      });
                    } else {
                      setValidation((prevState) => ({
                        ...prevState,
                        language: { error: false }
                      }));
                      setSpokenLanguages((prevState) => [...prevState, e.label]);
                    }
                  }}
                  placeholder="Language"
                  name="languages"
                  options={languages}
                />
                <label className="mt-2">
                  <AiOutlineInfoCircle color="#FFE13F" fontSize="20px" className="me-2" />
                  <small>You can select multiple options</small>
                </label>
              </div>
              <div className="col-lg-9">
                <div className="spoken-languages flex-wrap d-flex gap-3">
                  {spokenLanguages
                    ? spokenLanguages.map((language, i) => {
                        return (
                          <span
                            key={`language-${i}`}
                            className="d-flex align-items-center justify-content-between">
                            {language}{" "}
                            <button
                              className="bg-transparent p-0 m-0 border-0 rounded-0"
                              onClick={(e) => {
                                e.preventDefault();
                                setSpokenLanguages(
                                  spokenLanguages.filter((lang) => lang !== language)
                                );
                              }}>
                              <TiDelete color="#5EFF5A" fontSize="30px" />
                            </button>
                          </span>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-lg-3">
                <label
                  htmlFor="socialMediaReach"
                  className={validation.interests.error ? "mb-0" : null}>
                  Interests *
                </label>
                {validationErrorMessage(validation.interests.error)}
                <CustomDropdown
                  className={validation.interests.error ? "error-dropdown" : ""}
                  valueChanged={(e) => {
                    if (userInterests.includes(e.label)) {
                      toast.warn("This interest is already added.", {
                        toastId: "languageAlreadyAdded",
                        hideProgressBar: true,
                        style: options.dropdownStyle
                      });
                    } else {
                      setValidation((prevState) => ({
                        ...prevState,
                        interests: { error: false }
                      }));
                      setUserInterests((prevState) => [...prevState, e.label]);
                    }
                  }}
                  placeholder="Interest"
                  name="interests"
                  options={interests}
                />
                <label className="mt-2">
                  <AiOutlineInfoCircle color="#FFE13F" fontSize="20px" className="me-2" />
                  <small>You can select multiple options</small>
                </label>
              </div>
              <div className="col-lg-9">
                <div className="spoken-languages d-flex flex-wrap gap-3">
                  {userInterests
                    ? userInterests.map((interes, i) => {
                        return (
                          <span
                            key={`language-${i}`}
                            className="d-flex align-items-center justify-content-between">
                            {interes}{" "}
                            <button
                              className="bg-transparent p-0 m-0 border-0 rounded-0"
                              onClick={(e) => {
                                e.preventDefault();
                                setUserInterests(
                                  userInterests.filter((interest) => interest !== interes)
                                );
                              }}>
                              <TiDelete color="#5EFF5A" fontSize="30px" />
                            </button>
                          </span>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-12">
                <label htmlFor="academic" className={validation.academic.error ? "mb-0" : null}>
                  Education level *
                </label>
                {validationErrorMessage(validation.academic.error)}
                <CustomDropdown
                  className={validation.academic.error ? "error-dropdown" : ""}
                  valueChanged={(e) => {
                    setValidation((prevState) => ({
                      ...prevState,
                      academic: { error: false }
                    }));
                  }}
                  defaultValue={
                    getLocalStorage("t2")?.academic
                      ? {
                          value: getLocalStorage("t2").academic,
                          label: getLocalStorage("t2").academic
                        }
                      : false
                  }
                  placeholder="Select academic"
                  name="academic"
                  options={academic}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-12">
                <label htmlFor="jobStatus" className={validation.jobStatus.error ? "mb-0" : null}>
                  Job status *
                </label>
                {validationErrorMessage(validation.jobStatus.error)}
                <CustomDropdown
                  className={validation.jobStatus.error ? "error-dropdown" : ""}
                  valueChanged={(e) => {
                    setValidation((prevState) => ({
                      ...prevState,
                      jobStatus: { error: false }
                    }));
                  }}
                  defaultValue={
                    getLocalStorage("t2")?.jobStatus
                      ? {
                          value: getLocalStorage("t2").jobStatus,
                          label: getLocalStorage("t2").jobStatus
                        }
                      : false
                  }
                  placeholder="Select job status"
                  name="jobStatus"
                  options={jobStatus}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-12">
                <label
                  htmlFor="socialMediaReach"
                  className={validation.socialMediaReach.error ? "mb-0" : null}>
                  Social Media Followers / Subscribers *
                </label>
                {validationErrorMessage(validation.socialMediaReach.error)}
                <CustomDropdown
                  className={validation.socialMediaReach.error ? "error-dropdown" : ""}
                  valueChanged={(e) => {
                    setValidation((prevState) => ({
                      ...prevState,
                      socialMediaReach: { error: false }
                    }));
                  }}
                  defaultValue={
                    getLocalStorage("t2")?.socialMediaReach
                      ? socialMediaReach.filter(
                          (reach) => reach.value === getLocalStorage("t2").socialMediaReach
                        )
                      : false
                  }
                  placeholder="Select Social Media reach"
                  name="socialMediaReach"
                  options={socialMediaReach}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-12">
                <label htmlFor="socialMedia" className={validation.platform.error ? "mb-0" : null}>
                  Social Media *
                </label>
                {validationErrorMessage(validation.platform.error, validation.platform.message)}
                <div className="social-media-list">{socialMedia}</div>
                <button
                  className="gradient rounded-5 alt"
                  onClick={(e) => {
                    e.preventDefault();

                    if (!socialMediaListState.length) {
                      toast.warn("You cannot add any more platforms.", {
                        toastId: "addMorePlatforms",
                        hideProgressBar: true,
                        style: options.dropdownStyle
                      });
                      return;
                    }

                    if (socialMediaUrlRef.current) {
                      if (socialMediaUrlRef.current.value.trim() === "") {
                        toast.warn(
                          "You must add platform url before you add another social media.",
                          {
                            toastId: "socialMediaPlatformAdd",
                            hideProgressBar: true,
                            style: options.dropdownStyle
                          }
                        );
                      } else {
                        setSocialMedia(
                          socialMedia.concat(
                            <CreateElements index={socialMedia.length} key={socialMedia.length} />
                          )
                        );
                      }
                    }

                    if (!socialMediaUrlRef.current) {
                      setSocialMedia(
                        socialMedia.concat(
                          <CreateElements index={socialMedia.length} key={socialMedia.length} />
                        )
                      );
                    }
                  }}>
                  <span className="rounded-5 d-flex gap-2">
                    <MdOutlineAddCircleOutline color="#fff" fontSize="24px" />
                    Add platform
                  </span>
                </button>
              </div>
            </div>

            <div className="row mt-4 d-none">
              <div className="col-12 text-md-end">
                <button
                  ref={saveRef}
                  className="gradient alt d-inline-block save-form"
                  onClick={(e) => handleSubmit(e)}>
                  <span>Save form</span>
                </button>
              </div>
            </div>
          </>
        ) : null}
      </div>

      {showTier ? (
        <div className="d-flex align-items-center mt-4 justify-content-center flex-md-row flex-column-reverse">
          <button
            className="gradient alt small-height submit-now"
            // disabled={getLocalStorage("tier2") !== null ? false : true}
            onClick={(e) => handleSubmit(e)}>
            <span>Submit form now</span>
          </button>
          <button
            className="gradient fill small-height ms-md-3 large-width mb-md-0 mb-3 btn-save"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(e);
              if (getLocalStorage("tier2") !== null) {
                props?.refTier3?.current?.scrollIntoView({
                  alignToTop: true,
                  block: "start",
                  behavior: "smooth"
                });
              }
            }}>
            <span>Save and continue to Experience</span>
          </button>
        </div>
      ) : null}
    </form>
  );
};

export default Tier2;
